<template>
    <div class="sms-template-management">
      <!-- <h2 class="page-title">短信模板管理</h2> -->
      
      <!-- 搜索区域 -->
      <el-card class="search-card">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="模板名称">
            <el-input v-model="searchForm.name" placeholder="请输入模板名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-select v-model="searchForm.type" placeholder="请选择模板类型" clearable>
              <el-option v-for="item in templateTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="有效" value="1"></el-option>
              <el-option label="失效" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      
      <!-- 操作区域 -->
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增模板</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="multipleSelection.length === 0" @click="handleBatchDelete">批量删除</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="handleImport">导入</el-button>
        <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
      
      <!-- 表格区域 -->
      <el-table 
        :data="tableData" 
        border 
        style="width: 100%" 
        @selection-change="handleSelectionChange"
        v-loading="loading">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="模板ID" width="80"></el-table-column>
        <el-table-column prop="name" label="模板名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" label="短信内容" min-width="250" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" label="模板类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="getTypeTagType(scope.row.type)">{{ getTypeName(scope.row.type) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
        <el-table-column prop="status" label="模板状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-value="1"
              inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="statusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handlePreview(scope.row)">预览</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleTest(scope.row)">测试发送</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      
      <!-- 添加/编辑模板对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px">
        <el-form :model="templateForm" :rules="templateRules" ref="templateForm" label-width="100px">
          <el-form-item label="模板名称" prop="name">
            <el-input v-model="templateForm.name" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item label="模板类型" prop="type">
            <el-select v-model="templateForm.type" placeholder="请选择模板类型" style="width: 100%">
              <el-option v-for="item in templateTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短信内容" prop="content">
            <el-input 
              type="textarea" 
              v-model="templateForm.content" 
              placeholder="请输入短信内容，支持变量如${patient_name}" 
              :rows="5">
            </el-input>
            <div class="content-tip">
              <span>已输入 {{ templateForm.content.length }} 字，短信计 {{ calculateMessageCount(templateForm.content.length) }} 条</span>
              <el-popover
                placement="top-start"
                width="300"
                trigger="hover">
                <div class="variable-list">
                  <h4>支持的变量列表：</h4>
                  <p><strong>${patient_name}</strong> - 患者姓名</p>
                  <p><strong>${appointment_time}</strong> - 预约时间</p>
                  <p><strong>${doctor_name}</strong> - 医生姓名</p>
                  <p><strong>${department}</strong> - 科室名称</p>
                  <p><strong>${hospital_name}</strong> - 医院名称</p>
                </div>
                <el-button slot="reference" type="text">查看支持的变量</el-button>
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item label="模板状态">
            <el-radio-group v-model="templateForm.status">
              <el-radio label="1">有效</el-radio>
              <el-radio label="0">失效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="templateForm.remark" placeholder="请输入备注信息"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 预览模板对话框 -->
      <el-dialog title="短信模板预览" :visible.sync="previewDialogVisible" width="500px">
        <div class="template-preview">
          <div class="preview-header">
            <div>
              <span class="label">模板名称:</span>
              <span class="value">{{ previewTemplate.name }}</span>
            </div>
            <div>
              <span class="label">模板类型:</span>
              <span class="value">{{ getTypeName(previewTemplate.type) }}</span>
            </div>
          </div>
          <div class="preview-content">
            <div class="phone-mockup">
              <div class="phone-header">
                <span>中国移动</span>
                <span>10:30</span>
                <span>100%</span>
              </div>
              <div class="message-content">
                <div class="message-sender">短信助手 (1065xxxxx)</div>
                <div class="message-bubble">
                  {{ previewTemplate.renderedContent || previewTemplate.content }}
                </div>
                <div class="message-time">{{ getCurrentTime() }}</div>
              </div>
            </div>
          </div>
          <div class="preview-actions">
            <el-button size="small" @click="fillTestData">填充测试数据</el-button>
            <el-button size="small" type="primary" @click="handleTest(previewTemplate)">测试发送</el-button>
          </div>
        </div>
      </el-dialog>
  
      <!-- 测试发送对话框 -->
      <el-dialog title="测试发送" :visible.sync="testDialogVisible" width="400px">
        <el-form :model="testForm" :rules="testRules" ref="testForm" label-width="80px">
          <el-form-item label="接收手机" prop="phone">
            <el-input v-model="testForm.phone" placeholder="请输入接收短信的手机号码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="testDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="sendTestMessage">发 送</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SmsTemplateManagement',
    data() {
      return {
        // 搜索表单
        searchForm: {
          name: '',
          type: '',
          status: ''
        },
        
        // 表格加载状态
        loading: false,
        
        // 分页相关
        currentPage: 1,
        pageSize: 10,
        total: 0,
        
        // 表格数据
        tableData: [],
        multipleSelection: [],
        
        // 模板类型选项
        templateTypes: [
          { value: '1', label: '预约提醒' },
          { value: '2', label: '随访提醒' },
          { value: '3', label: '报告通知' },
          { value: '4', label: '复诊提醒' },
          { value: '5', label: '用药提醒' },
          { value: '6', label: '缴费通知' },
          { value: '7', label: '满意度调查' },
          { value: '8', label: '节日问候' },
          { value: '9', label: '其他通知' }
        ],
        
        // 对话框相关
        dialogVisible: false,
        dialogTitle: '新增短信模板',
        templateForm: {
          id: '',
          name: '',
          content: '',
          type: '',
          status: '1',
          remark: ''
        },
        
        // 表单验证规则
        templateRules: {
          name: [
            { required: true, message: '请输入模板名称', trigger: 'blur' },
            { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择模板类型', trigger: 'change' }
          ],
          content: [
            { required: true, message: '请输入短信内容', trigger: 'blur' },
            { min: 5, max: 500, message: '长度在 5 到 500 个字符', trigger: 'blur' }
          ]
        },
        
        // 预览相关
        previewDialogVisible: false,
        previewTemplate: {
          name: '',
          type: '',
          content: '',
          renderedContent: ''
        },
        
        // 测试发送相关
        testDialogVisible: false,
        testForm: {
          phone: ''
        },
        testRules: {
          phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      this.fetchData();
    },
    methods: {
      // 获取数据
      fetchData() {
        this.loading = true;
        
        // 模拟API请求延迟
        setTimeout(() => {
          // 生成假数据
          const mockData = [
            {
              id: '1001',
              name: '门诊预约提醒',
              content: '尊敬的${patient_name}，您预约的${hospital_name}${department}${doctor_name}医生的门诊，时间为${appointment_time}，请提前半小时到达医院。如需取消，请提前致电取消。',
              type: '1',
              createTime: '2023-04-12 10:25:30',
              status: '1',
              remark: '适用于门诊预约提醒'
            },
            {
              id: '1002',
              name: '复诊提醒模板',
              content: '${patient_name}您好，根据医生建议，您的复诊时间为${appointment_time}，请按时前往${hospital_name}${department}就诊，祝您早日康复！',
              type: '4',
              createTime: '2023-04-10 14:30:15',
              status: '1',
              remark: '适用于患者复诊提醒'
            },
            {
              id: '1003',
              name: '检查报告通知',
              content: '尊敬的${patient_name}，您在${hospital_name}的检查报告已出，请登录医院APP查看或前往医院领取纸质报告。如有疑问请咨询您的主治医生。',
              type: '3',
              createTime: '2023-04-08 09:15:20',
              status: '1',
              remark: '适用于检查报告通知'
            },
            {
              id: '1004',
              name: '用药提醒',
              content: '${patient_name}您好，请记得按医嘱按时服用药物，保持良好的生活习惯。如有不适，请及时就医。祝您健康！',
              type: '5',
              createTime: '2023-04-05 16:45:10',
              status: '1',
              remark: '适用于患者用药提醒'
            },
            {
              id: '1005',
              name: '满意度调查',
              content: '尊敬的${patient_name}，感谢您近期在${hospital_name}就诊，为提升服务质量，诚邀您参与满意度调查，请点击链接：https://survey.hospital.com/s/abc123 完成调查，谢谢！',
              type: '7',
              createTime: '2023-04-01 11:20:35',
              status: '1',
              remark: '适用于患者满意度调查'
            },
            {
              id: '1006',
              name: '新年祝福',
              content: '尊敬的${patient_name}，${hospital_name}全体医护人员恭祝您新年快乐，身体健康，万事如意！',
              type: '8',
              createTime: '2023-03-25 10:10:40',
              status: '1',
              remark: '适用于新年祝福'
            },
            {
              id: '1007',
              name: '缴费通知',
              content: '${patient_name}您好，您在${hospital_name}有￥XXX元医疗费用未结算，请及时到医院收费处或通过医院APP完成支付。',
              type: '6',
              createTime: '2023-03-20 14:50:25',
              status: '1',
              remark: '适用于缴费通知'
            },
            {
              id: '1008',
              name: '随访提醒',
              content: '${patient_name}您好，根据您的病情，医生安排在${appointment_time}对您进行随访，请保持电话畅通，如有疑问请联系${doctor_name}医生。',
              type: '2',
              createTime: '2023-03-15 09:35:50',
              status: '1',
              remark: '适用于随访提醒'
            },
            {
              id: '1009',
              name: '停诊通知',
              content: '尊敬的${patient_name}，因特殊原因，您预约的${appointment_time}${department}${doctor_name}医生的门诊临时停诊，请选择其他时间重新预约，给您带来不便敬请谅解。',
              type: '9',
              createTime: '2023-03-10 15:40:15',
              status: '1',
              remark: '适用于停诊通知'
            },
            {
              id: '1010',
              name: '老模板-疫苗接种提醒',
              content: '${patient_name}您好，提醒您按计划于${appointment_time}到${hospital_name}接种疫苗，请携带接种证及身份证件，谢谢配合。',
              type: '9',
              createTime: '2022-12-05 10:20:30',
              status: '0',
              remark: '已过期，不再使用'
            }
          ];
          
          this.total = mockData.length;
          const start = (this.currentPage - 1) * this.pageSize;
          const end = start + this.pageSize;
          this.tableData = mockData.slice(start, end);
          
          this.loading = false;
        }, 800);
      },
      
      // 多选变化
      handleSelectionChange(selection) {
        this.multipleSelection = selection;
      },
      
      // 搜索
      handleSearch() {
        this.currentPage = 1;
        this.fetchData();
      },
      
      // 重置搜索
      resetSearch() {
        this.$refs.searchForm.resetFields();
        this.handleSearch();
      },
      
      // 变更页面大小
      handleSizeChange(val) {
        this.pageSize = val;
        this.fetchData();
      },
      
      // 变更页码
      handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchData();
      },
      
      // 添加模板
      handleAdd() {
        this.dialogTitle = '新增短信模板';
        this.templateForm = {
          id: '',
          name: '',
          content: '',
          type: '',
          status: '1',
          remark: ''
        };
        this.dialogVisible = true;
        
        // 重置表单验证
        this.$nextTick(() => {
          this.$refs.templateForm.clearValidate();
        });
      },
      
      // 编辑模板
      handleEdit(row) {
        this.dialogTitle = '编辑短信模板';
        this.templateForm = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
        
        // 重置表单验证
        this.$nextTick(() => {
          this.$refs.templateForm.clearValidate();
        });
      },
      
      // 删除模板
      handleDelete(row) {
        this.$confirm('确认删除该短信模板?', '警告', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          this.$message({
            type: 'success',
            message: `删除成功：${row.name}`
          });
          this.fetchData();
        }).catch(() => {
          // 取消删除
        });
      },
      
      // 批量删除
      handleBatchDelete() {
        if (this.multipleSelection.length === 0) {
          this.$message({
            type: 'warning',
            message: '请至少选择一条记录'
          });
          return;
        }
        
        const names = this.multipleSelection.map(item => item.name).join('、');
        
        this.$confirm(`确认删除选中的 ${this.multipleSelection.length} 条模板?`, '警告', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          this.$message({
            type: 'success',
            message: `批量删除成功：${names}`
          });
          this.fetchData();
        }).catch(() => {
          // 取消删除
        });
      },
      
      // 导入模板
      handleImport() {
        this.$message({
          type: 'info',
          message: '导入功能开发中...'
        });
      },
      
      // 导出模板
      handleExport() {
        this.$message({
          type: 'success',
          message: '模板数据导出成功'
        });
      },
      
      // 提交表单
      submitForm() {
        this.$refs.templateForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            
            // 模拟API请求
            setTimeout(() => {
              if (this.templateForm.id) {
                this.$message({
                  type: 'success',
                  message: `模板更新成功：${this.templateForm.name}`
                });
              } else {
                this.$message({
                  type: 'success',
                  message: `模板添加成功：${this.templateForm.name}`
                });
              }
              
              this.dialogVisible = false;
              this.fetchData();
              this.loading = false;
            }, 800);
          } else {
            return false;
          }
        });
      },
      
      // 预览模板
      handlePreview(row) {
        this.previewTemplate = JSON.parse(JSON.stringify(row));
        this.previewDialogVisible = true;
      },
      
      // 填充测试数据
      fillTestData() {
        const testData = {
          patient_name: '许昊然',
          appointment_time: '2023-04-15 上午9:30',
          doctor_name: '李医生',
          department: '内科',
          hospital_name: '仁爱医院'
        };
        
        // 替换变量
        let content = this.previewTemplate.content;
        for (const [key, value] of Object.entries(testData)) {
          content = content.replace(new RegExp(`\\$\\{${key}\\}`, 'g'), value);
        }
        
        this.previewTemplate.renderedContent = content;
      },
      
      // 测试发送
      handleTest(row) {
        this.testForm.phone = '';
        this.previewTemplate = row;
        this.testDialogVisible = true;
        
        // 重置表单验证
        this.$nextTick(() => {
          if (this.$refs.testForm) {
            this.$refs.testForm.clearValidate();
          }
        });
      },
      
      // 发送测试短信
      sendTestMessage() {
        this.$refs.testForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            
            // 模拟API请求
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: `测试短信已发送至：${this.testForm.phone}`
              });
              
              this.testDialogVisible = false;
              this.loading = false;
            }, 800);
          } else {
            return false;
          }
        });
      },
      
      // 状态变更
      statusChange(row) {
        const statusText = row.status === '1' ? '启用' : '禁用';
        this.$message({
          type: 'success',
          message: `模板已${statusText}：${row.name}`
        });
      },
      
      // 获取类型名称
      getTypeName(type) {
        const found = this.templateTypes.find(item => item.value === type);
        return found ? found.label : '未知类型';
      },
      
      // 获取类型标签样式
      getTypeTagType(type) {
        const typeMap = {
          '1': 'primary',
          '2': 'success',
          '3': 'info',
          '4': 'warning',
          '5': 'danger',
          '6': '',
          '7': 'primary',
          '8': 'success',
          '9': 'info'
        };
        return typeMap[type] || '';
      },
      
      // 计算短信字数
      calculateMessageCount(length) {
        if (length <= 70) {
          return 1;
        } else {
          return Math.ceil(length / 67);
        }
      },
      
      // 获取当前时间
      getCurrentTime() {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    }
  }
  </script>
  
  <style scoped>
  .sms-template-management {
    padding: 20px;
  }
  
  .page-title {
    margin-bottom: 20px;
    font-weight: 500;
    color: #303133;
  }
  
  .search-card {
    margin-bottom: 20px;
  }
  
  .operation-bar {
    margin-bottom: 20px;
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  
  .content-tip {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    color: #909399;
    font-size: 12px;
  }
  
  .variable-list h4 {
    margin-top: 0;
    margin-bottom: 10px;
  }
  
  .variable-list p {
    margin: 5px 0;
  }
  
  .template-preview {
    width: 100%;
  }
  
  .preview-header {
    margin-bottom: 15px;
  }
  
  .preview-header div {
    margin-bottom: 5px;
  }
  
  .preview-header .label {
    font-weight: bold;
    margin-right: 10px;
    color: #606266;
  }
  
  .preview-content {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  .phone-mockup {
    width: 300px;
    height: 500px;
    border: 10px solid #dcdfe6;
    border-radius: 20px;
    background-color: #f2f6fc;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .phone-header {
    height: 30px;
    background-color: #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    color: #606266;
    font-size: 12px;
  }
  
  .message-content {
    padding: 15px;
  }
  
  .message-sender {
    color: #606266;
    font-size: 12px;
    margin-bottom: 8px;
  }
  
  .message-bubble {
    background-color: #ecf5ff;
    padding: 12px;
    border-radius: 8px;
    color: #303133;
    font-size: 14px;
    margin-bottom: 8px;
    word-break: break-word;
    border: 1px solid #d9ecff;
  }
  
  .message-time {
    font-size: 11px;
    color: #909399;
    text-align: center;
  }
  
  .preview-actions {
    text-align: center;
  }
  </style>